import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent } from '@mui/material';

const CategoriesSection = () => {
  const categories = [
    {
      number: '01',
      title: 'родитель (законный представитель) ребёнка в возрасте от 0 до 8 лет, обеспечивающие получение детьми образования на любом этапе (дошкольном или общем) в форме семейного образования;'
    },
    {
      number: '02',
      title: 'родитель (законный представитель) ребёнка в возрасте от 0 до 8 лет, не получающие услуги образования в образовательной организации;'
    },
    {
      number: '03',
      title: 'родитель (законный представитель) ребёнка в возрасте от 0 до 8 лет с особыми образовательными потребностями;'
    },
    {
      number: '04',
      title: 'гражданин, желающий принять на воспитание в свою семью ребёнка из числа детей-сирот, детей, оставшихся без попечения родителей.'
    }
  ];

  return (
    <Box 
      sx={{ 
        background: 'linear-gradient(135deg, #00ACC1 0%, #81C784 50%, #C5E1A5 100%)',
        py: { xs: 6, md: 8 },
        position: 'relative',
      }}
    >
      {/* Декоративные круги */}
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          right: '5%',
          width: { xs: 150, md: 250 },
          height: { xs: 150, md: 250 },
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)',
          filter: 'blur(40px)',
        }}
      />

      <Container maxWidth="xl">
        <Typography
          variant="h3"
          sx={{
            textAlign: 'center',
            mb: 6,
            fontWeight: 700,
            color: '#1a1a1a',
            fontSize: { xs: '1.75rem', md: '2.5rem' }
          }}
        >
          Получателями услуг являются граждане различных категорий:
        </Typography>

        <Grid container spacing={3}>
          {categories.map((category, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <Card
                sx={{
                  height: '100%',
                  borderRadius: 4,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                  },
                  backgroundColor: 'white',
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: '3rem',
                      fontWeight: 700,
                      color: '#00ACC1',
                      mb: 3,
                    }}
                  >
                    {category.number}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.primary',
                      lineHeight: 1.7,
                      fontSize: '0.95rem',
                    }}
                  >
                    {category.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CategoriesSection;
